
export default defineNuxtPlugin((nuxtApp) => {
    return {
        provide : {
            appRoutes
        }
    }
})